import { useDispatch, useSelector } from 'react-redux'
import { Pagination } from '../../../../../common/pagination'
import {
  changeFilterTable,
  getFilterTable,
  selectTotalRecords,
} from '../../store/slice'

export const PaginationTableReport = () => {
  const dispatch = useDispatch()

  const page = useSelector(getFilterTable('Page'))
  const pageSize = useSelector(getFilterTable('PageSize'))
  const total = useSelector(selectTotalRecords)

  //Actions
  const handleSetPage = (value) => {
    dispatch(
      changeFilterTable({
        Page: value,
      }),
    )
  }

  const setPageSize = (value) => {
    dispatch(
      changeFilterTable({
        PageSize: value,
        Page: 1,
      }),
    )
  }

  return (
    <div style={{ paddingTop: 12 }}>
      <Pagination
        page={page}
        pageSize={pageSize}
        total={total}
        setPage={handleSetPage}
        setPageSize={setPageSize}
        pageSizeOptions={[
          { label: 20, value: 20 },
          { label: 50, value: 50 },
          { label: 100, value: 100 },
        ]}
      />
    </div>
  )
}
